export enum Position {
  DJ = 'DJ',
  PRODUCER = 'Producer',
  PROMOTER = 'Promoter',
  AGENT = 'Agent',
  MANAGER = 'Manager',
  SOUND_ENGINEER = 'Sound_Engineer',
  LIGHT_DESIGNER = 'Light_Designer',
  OTHER = 'Other',
}